/**
 * "Acceso a los adjuntos" de una tabla: quién abre sus archivos.
 * Ver extras_mg/api/archivos/views.py.
 */
export default (client) => ({
  obtener(tablaId) {
    return client.get(`/extras-mg/archivos/tabla/${tablaId}/`)
  },
  guardar(tablaId, modo, personas) {
    return client.put(`/extras-mg/archivos/tabla/${tablaId}/`, {
      modo,
      personas,
    })
  },
})
